import styled from 'styled-components';

import {
  HERO_FONT_DISPLAY,
  LandingHero,
} from 'constants/landing-hero';

import { blink, sheen } from './keyframes';

const MOBILE = '@media (max-width: 768px)';
const NARROW_DESKTOP = '@media (max-width: 1024px)';

export const Wrap = styled.div`
  padding: 9.6rem 7.2rem 8.8rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4.4rem;
  width: 100%;

  ${MOBILE} {
    padding: 5.6rem 2.4rem 4.8rem;
  }
`;

export const DemoRow = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: center;
  gap: 4rem;
  width: 100%;
  padding-top: 1.6rem;

  ${NARROW_DESKTOP} {
    flex-direction: column;
    align-items: center;
  }
`;

export const Intro = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 2.2rem;
  text-align: center;
  max-width: 84rem;
`;

export const Badge = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 1rem;
  background: ${LandingHero.badgeBg};
  border: 0.1rem solid ${LandingHero.badgeBorder};
  box-shadow: 0 0 3rem -0.8rem ${LandingHero.badgeShadow};
  border-radius: 999rem;
  padding: 0.9rem 1.8rem;
`;

export const BadgeDot = styled.div`
  width: 0.9rem;
  height: 0.9rem;
  border-radius: 999rem;
  background: ${LandingHero.liveDot};
  box-shadow: 0 0 1rem ${LandingHero.liveDot};
  animation: ${blink} 1.8s ease-in-out infinite;

  @media (prefers-reduced-motion: reduce) {
    animation: none;
  }
`;

export const BadgeLabel = styled.div`
  font-size: 1.3rem;
  font-weight: 700;
  color: ${LandingHero.badgeText};
`;

export const Heading = styled.div`
  font-family: ${HERO_FONT_DISPLAY};
  font-weight: 800;
  font-size: 5.2rem;
  line-height: 1.04;
  letter-spacing: -0.18rem;
  color: ${LandingHero.textPrimary};

  ${MOBILE} {
    font-size: 3.4rem;
    letter-spacing: -0.08rem;
  }
`;

export const Description = styled.div`
  font-size: 1.7rem;
  line-height: 1.6;
  color: ${LandingHero.textMuted};
  max-width: 64rem;
`;

export const CtaRow = styled.div`
  display: flex;
  align-items: center;
  gap: 1.4rem;
  flex-wrap: wrap;
  justify-content: center;
`;

export const PrimaryCta = styled.button`
  position: relative;
  overflow: hidden;
  background: ${LandingHero.skyCtaGradient};
  color: ${LandingHero.skyCtaText};
  font-size: 1.6rem;
  font-weight: 800;
  padding: 1.8rem 3.4rem;
  border-radius: 1.4rem;
  border: none;
  cursor: pointer;
  font-family: inherit;
  box-shadow:
    0 1.4rem 3.4rem -1rem ${LandingHero.skyCtaShadow},
    inset 0 0.1rem 0 ${LandingHero.ctaInsetHighlight};
  transition: transform 0.25s ease;

  &::after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 40%;
    height: 100%;
    background: linear-gradient(
      90deg,
      transparent,
      ${LandingHero.ctaSheen},
      transparent
    );
    animation: ${sheen} 3.6s ease-in-out infinite;
  }

  &:hover {
    transform: translateY(-0.2rem);
  }

  @media (prefers-reduced-motion: reduce) {
    &::after {
      animation: none;
    }
  }
`;

export const SecondaryCta = styled.button`
  background: transparent;
  color: ${LandingHero.textBody};
  font-size: 1.6rem;
  font-weight: 700;
  padding: 1.7rem 3rem;
  border-radius: 1.4rem;
  border: 0.1rem solid ${LandingHero.ghostBorder};
  cursor: pointer;
  font-family: inherit;
  transition: border-color 0.25s ease, background-color 0.25s ease, transform 0.25s ease;

  &:hover {
    color: ${LandingHero.textPrimary};
    border-color: ${LandingHero.ghostBorderHover};
    background: ${LandingHero.ghostBgHover};
    transform: translateY(-0.1rem);
  }
`;

export const Footnote = styled.div`
  font-size: 1.3rem;
  color: ${LandingHero.textFaint};
`;
